<template>
  <div class="homePage">
    <!-- <Header activeIndex="/news"/> -->
    <div>
      <img src="@/assets/image/newsbanner.png" style="width:100%" alt=""/>
    </div>
    <div class="pagew mid">
      <div class="guide">
        <span style="cursor:pointer" @click="back">新闻公告 ></span>
        <span>{{ title }}</span>
      </div>
      <div class="title">{{ title }}</div>
      <div class="content" v-html="html">
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/index";
import * as request from '@/api/api.js'
import {getNewsListDetails} from "@/api/api.js";


export default {
  // components: {Footer, Header},
  data() {
    return {
      title: '',
      html: ''
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      request.getNewsListDetails({newsId:this.$route.query.id}).then(res=>{
        this.html = res.data.intro;
        this.title = res.data.title;
      })
    },
    go(code) {
      this.index = code;
    },
    back() {
      this.$router.push({
        path: '/news'
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.list ::v-deep .el-pagination .el-pager li .active {
  background-color: #25877d !important;
}

.homePage {
  width: 100%;

  .mid {
    padding: 40px 0;
  }

  .guide {
    text-align: start;
    color: #999;

    font-size: 14px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    text-align: start;
    margin-top: 35px;
  }

  .content {
    margin-top: 35px;
    text-align: start;

    .content-text {
      margin-top: 40px;
      margin-bottom: 40px;
    }
  }


  .el-carousel__item .is-active {
    :deep(.is-active) {
      background-color: red;
    }

  }

  .el-carousel__item:nth-child(2n) {
    // background-color: gray;
  }

  .el-carousel__item:nth-child(2n+1) {
    // background-color: gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/news/newsdetail.vue